import Header from "components/Header";
import MainLayout from "layouts/Main";

export default function LoadDetailSkeleton({ title = "Load Details" }: { title?: string }) {
  return (
    <MainLayout
      desktopTitle="Load Search"
      className="!pr-14 !pl-16 mobile:!px-5"
      customHeader={<Header label={title} />}>
      <div className="flex flex-col gap-4 animate-pulse">
        {/* Company Name */}
        <div className="flex justify-between items-center">
          <div className="h-6 w-64 bg-gray-300 rounded" />
          <div className="h-10 w-32 bg-gray-300 rounded" />
        </div>

        {/* Origin - Destination Header */}
        <div className="flex items-center gap-4">
          <div className="h-5 w-48 bg-gray-300 rounded" />
          <div className="h-4 w-8 bg-gray-300 rounded" />
          <div className="h-5 w-48 bg-gray-300 rounded" />
        </div>

        {/* Load Details Card */}
        <div className="grid grid-cols-3 desktop:grid-cols-7 gap-4 p-4 bg-foreground rounded-lg">
          {[...Array(7)].map((_, index) => (
            <div key={index} className="flex flex-col gap-2">
              <div className="h-3 w-16 bg-gray-300 rounded" />
              <div className="h-4 w-20 bg-gray-300 rounded" />
            </div>
          ))}
        </div>

        {/* Box Group */}
        <div className="grid grid-cols-1 desktop:grid-cols-4 gap-4">
          {[...Array(4)].map((_, index) => (
            <div key={index} className="p-4 bg-foreground rounded-lg">
              <div className="h-5 w-32 bg-gray-300 rounded mb-4" />
              <div className="flex flex-col gap-2">
                <div className="h-4 w-full bg-gray-300 rounded" />
                <div className="h-4 w-3/4 bg-gray-300 rounded" />
                <div className="h-4 w-1/2 bg-gray-300 rounded" />
              </div>
            </div>
          ))}
        </div>

        {/* Notes */}
        <div className="my-4">
          <div className="h-5 w-16 bg-gray-300 rounded mb-2" />
          <div className="h-4 w-48 bg-gray-300 rounded" />
        </div>

        {/* Target Rate & Status */}
        <div className="flex justify-between items-center p-4 bg-foreground rounded-lg">
          <div className="h-6 w-40 bg-gray-300 rounded" />
          <div className="h-6 w-32 bg-gray-300 rounded" />
        </div>

        {/* Bidding Section */}
        <div className="p-4 bg-foreground rounded-lg">
          <div className="h-6 w-24 bg-gray-300 rounded mb-4" />
          <div className="flex flex-col gap-3">
            <div className="h-10 w-full bg-gray-300 rounded" />
            <div className="h-10 w-full bg-gray-300 rounded" />
          </div>
        </div>

        {/* Map Section */}
        <div className="mt-4">
          <div className="h-5 w-12 bg-gray-300 rounded mb-2" />
          <div className="h-64 w-full bg-gray-300 rounded" />
        </div>
      </div>
    </MainLayout>
  );
}
